/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import { useI18N } from '../../hoc/withI18N';
import { ICartInfoMessage } from '../../../../interfaces/my-puratos/atoms/checkout/ICartInfoMessage';

export const CartInfoMessage: FunctionComponent<ICartInfoMessage> = ({ cartAlerts }) => {
    const [isCollapsed, setIsCollapsed] = useState<boolean>(true);
    const [collapseText, setCollapseText] = useState<'read more' | 'read less'>('read more');
    const [overflowActive, setOverflowActive] = useState<boolean>(false);

    const ParagraphRef = useRef<HTMLParagraphElement | null>(null);

    const translate = useI18N();

    useEffect(() => {
        setCollapseText(isCollapsed ? 'read more' : 'read less');
    }, [isCollapsed]);

    useEffect(() => {
        setOverflowActive(
            ParagraphRef.current.offsetHeight < ParagraphRef.current.scrollHeight ||
                ParagraphRef.current.offsetWidth < ParagraphRef.current.scrollWidth
                ? true
                : false
        );
    }, [overflowActive]);

    return (
        <div className="checkout-card__group--item p-margin-none">
            <p className="cart__content--info-title">{cartAlerts.alertTitle}</p>
            <React.Fragment>
                <p className={`cart__content--info-text ${isCollapsed && 'text-ellipsis'}`} ref={ParagraphRef}>
                    {cartAlerts.alertMessage}
                </p>
                {overflowActive && (
                    <a className="cart__content--info-collapse" onClick={() => setIsCollapsed(!isCollapsed)}>
                        {translate(collapseText) || collapseText}
                    </a>
                )}
            </React.Fragment>
        </div>
    );
};
